<template>
  <div class="ps-2 pe-2">
    <div class="subform-row-display w-100" :class="dynamicGap" :style="subFormRowStyle" :data-subform-row="rowIndex">
      <div v-for="item in row" :style="calcGridItemStyle(item)" :key="`sf-row-${rowUid}-${item.id}`">
        <div :class="hiddenClass(item)">
          <sub-form-item-store
            :key="`sf-${rowUid}-${item.id}`"
            :path="`${path}/${getItemIndex(item)}`"
            :read-only="readOnly"
            :is-list-view-modal="isListViewModal"
            :row-index="rowIndex"
            :type="item.type"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubFormItemStore from './SubFormItemStore.vue'
import { filter, forEach, get, groupBy, map, sortBy, isUndefined } from 'lodash'
import Collapse from '../Collapse.vue'

export default {
  name: 'SubFormRow',
  components: {
    Collapse,
    SubFormItemStore,
  },
  props: {
    path: {
      type: String,
    },
    listHead: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    showRemoveButton: {
      type: Boolean,
      default: true,
    },
    isListViewModal: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
    },
    rowIndex: {
      type: Number,
    },
    name: {
      type: String,
    },
  },
  data() {
    return {
      collapsibleGridView: false,
      collapsed: false,
    }
  },
  computed: {
    dynamicGap() {
      return this.isDetailView ? 'gap-2' : 'gap-1'
    },
    formGridStyle() {
      const subform = filter(this.row, (item) => !isUndefined(item.posRow) && !item.hidden)
      let grouped = groupBy(subform, 'posRow')
      let style = 'grid-template-areas: '
      map(grouped, (subFormGroup) => {
        let col = 0
        style += '"'
        forEach(subFormGroup, (item) => {
          for (let i = col; i < item.posCol; i++) {
            style += '. '
            col++
          }
          for (let i = 0; i < item.posSizex; i++) {
            style += `${item.id} `
            col++
          }
        })
        for (let j = col; j < 12; j++) {
          style += '. '
        }
        style += '"'
      })
      style += ';'
      return style
    },
    isFormGridView() {
      return this.subFormView === 'FormGrid'
    },
    isCollapsibleGridView() {
      return this.subFormView === 'CollapsibleGrid'
    },
    isDetailView() {
      return this.subFormView === 'Grid'
    },
    isListView() {
      return this.subFormView === 'List'
    },
    subFormRowStyle() {
      if (this.isListViewModal) return this.formGridStyle
      switch (this.subFormView) {
        case 'Default':
        case 'List':
          return `grid-auto-flow: column;align-items: end; ${this.gridTemplateColumns}`
        case 'Grid':
          return 'grid-auto-flow: row;align-items: start;'
        case 'FormGrid':
        case 'CollapsibleGrid':
          return `${this.formGridStyle}; grid-template-columns: repeat(auto-fit, minmax(0, 1fr))`
      }
    },
    gridTemplateColumns() {
      const frames = new Array(this.row.length).fill('1fr')
      return `grid-template-columns: ${frames.join(' ')}`
    },
    subFormView() {
      return this.$get('subformView')
    },
    row() {
      const row = this.$get('subFormRowByPath')(this.path)
      return sortBy(
        get(row, 'items', []).filter((item) => {
          if (this.isListView) {
            return this.listHead.find((head) => head.name === item.name) && !item.hidden && item.id !== 'ID'
          } else {
            return this.listHead.find((head) => head.label === item.label) && item.id !== 'ID'
          }
        }),
        ['posRow', 'posCol']
      )
    },
    rowUid() {
      const row = this.$get('subFormRowByPath')(this.path)
      return get(row, 'rowUid')
    },
  },
  methods: {
    get,
    calcGridItemStyle(item) {
      let style = 'align-self: end;'
      if (this.isFormGridView || this.isCollapsibleGridView || this.isListViewModal) style += `grid-area: ${item.id};`
      if (this.isListView) style += 'white-space: nowrap;'
      return style
    },
    getItemIndex(item) {
      const row = this.$get('subFormRowByPath')(this.path)
      return row.items.findIndex((rowItem) => item.id === rowItem.id)
    },
    hiddenClass(item) {
      return item.hidden
        ? this.isFormGridView || this.isCollapsibleGridView || this.isListViewModal
          ? 'hidden'
          : 'invisible'
        : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.panel-heading.collapsible {
  width: 100%;
  display: flex;
  align-items: center;
  background: $color-primary-light3;
  color: $color-text-secondary;
  padding: 10px;
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  .panel-title.text-truncate {
    color: $color-text-secondary;
  }
  .material-icons {
    transition: 0.5s all;
    color: $color-text-secondary;
    &.expand-more {
      transform: rotate(180deg);
    }
  }
  .collapsible-remove-button {
    color: $color-white;
    &:hover {
      color: $color-primary-light1;
    }
  }
  .pointer-cursor {
    cursor: pointer;
  }
}
@media (min-width: $mobile-media-query) {
  .subform-row-display {
    display: grid;
  }
}
</style>
